import axios from "axios";
import { logDetailed } from "../../helpers/utils";
import { openPopup } from "../../helpers/popup";

export const launchPDF = ({ getters }, fileName) => {
  logDetailed("actions", "launchPDF for " + fileName, getters.isOpenedInApp);
  return axios.get("/api/helpcenter/launchPDF/?fileName=" + fileName, {responseType: "arraybuffer"})
    .then(response => {
      var file = new Blob([response.data], {type: "application/pdf"});
      var fileURL = URL.createObjectURL(file);
      if (getters.isOpenedInApp)
        window.location.href = fileURL;
      else
        openPopup(fileURL);
    }); 
} 

export const openHelpDialog = ({ dispatch, commit }) => {
  dispatch("getKnowledgeCenterSettings");
  dispatch("getVideoLibrary");
  dispatch("getBestPracticesEntries");
  commit("openHelpDialog");
}

export const getKnowledgeCenterSettings = ({ commit, getters }) => {
  logDetailed("actions", "knowledgeCenterSettings", getters.isOpenedInApp);
  return axios.get("/api/helpcenter/knowledgeCenterSettings")
    .then(response => {
      commit("setKnowledgeCenterSettings", response.data);
      return Promise.resolve(response);
    }); 
} 

export const getVideoLibrary = ({ commit, getters }) => {
  logDetailed("actions", "videoLibrary", getters.isOpenedInApp);
  return axios.get("/api/helpcenter/videoLibrary")
    .then(response => {
      var parsedJson = JSON.parse(response.data);
      commit("setVideoLibrary", parsedJson);
      return Promise.resolve(response);
    }); 
}

export const launchVideo = ({ commit, getters }, id) => {
  logDetailed("actions", "launchVideo", getters.isOpenedInApp);
  commit("setKnowledgeCenterVideoSrc", "api/helpcenter/launchVideo/?Id=" + id);
  commit("openVideoViewer", {isKnowledgeCenterVideo: true});
} 

export const getBestPracticesEntries = ({ commit, getters }) => {
  logDetailed("actions", "bestPracticesEntries", getters.isOpenedInApp);
  return axios.get("/api/helpcenter/bestPractices")
    .then(response => {
      var parsedJson = JSON.parse(response.data);
      commit("setBestPracticesEntries", parsedJson);
      return Promise.resolve(response);
    }); 
} 